/**
 * Store for managing the Connection Info dialog state.
 * Allows any part of the app to trigger the dialog opening.
 */

import { create } from 'zustand';
import type { Connection } from '../../../types/electron';

type ServerInfo = {
  version: string;
  edition?: string;
  platform?: string;
  isLoading: boolean;
  error?: string;
};

type ConnectionInfoDialogState = {
  isOpen: boolean;
  connection: Connection | null;
  serverInfo: ServerInfo;
};

type ConnectionInfoDialogActions = {
  openDialog: (connection: Connection) => void;
  closeDialog: () => void;
  setServerInfo: (info: Partial<ServerInfo>) => void;
};

type ConnectionInfoDialogStore = ConnectionInfoDialogState & ConnectionInfoDialogActions;

const initialServerInfo: ServerInfo = {
  version: '',
  isLoading: false,
};

const initialState: ConnectionInfoDialogState = {
  isOpen: false,
  connection: null,
  serverInfo: initialServerInfo,
};

export const useConnectionInfoDialogStore = create<ConnectionInfoDialogStore>((set) => ({
  ...initialState,

  openDialog: (connection) =>
    set({
      isOpen: true,
      connection,
      serverInfo: { ...initialServerInfo, isLoading: true },
    }),

  closeDialog: () =>
    set({
      isOpen: false,
      connection: null,
      serverInfo: initialServerInfo,
    }),

  setServerInfo: (info) =>
    set((state) => ({
      serverInfo: { ...state.serverInfo, ...info },
    })),
}));
